import { useState } from "react";
import { useForm } from "@mantine/form";
import {
  Alert,
  Container,
  PasswordInput,
  Text,
  Paper,
  Group,
  Button,
  Stack,
  Loader,
  Center,
} from "@mantine/core";
import { useStore } from "../store";
import { setPassword } from "../api";
import { useLocation } from "wouter";
import { IconInfoCircle } from "@tabler/icons-react";

export default function ResetPassword({ params }) {
  const [, setLocation] = useLocation();
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const authToken = useStore((state) => state.authToken);

  const form = useForm({
    initialValues: {
      token: params.token,
      newPassword: "",
    },
    validate: {
      newPassword: (val) =>
        val.length < 8 ? "Password must be at least 8 characters" : null,
      // emailAddress: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
    },
  });

  if (authToken) {
    return (
      <Container size="sm" mt="xl">
        <Paper radius="md" p="xl" withBorder>
          <Text size="lg" fw={500}>
            You are logged in
          </Text>
        </Paper>
      </Container>
    );
  }

  const errorIcon = <IconInfoCircle />;

  return (
    <Container size="sm" mt="xl">
      {errorMessage && (
        <Alert
          variant="light"
          color="red"
          title="Login Failed"
          mb="lg"
          icon={errorIcon}
        >
          {errorMessage}
        </Alert>
      )}

      <Paper radius="md" p="xl" withBorder>
        <Text size="lg" mb="lg" fw={500}>
          Set a New Password
        </Text>
        {/* 
        <Divider label="Reset Password" labelPosition="center" my="lg" /> */}

        <form
          onSubmit={form.onSubmit((values) => {
            setIsFetching(true);
            setErrorMessage(null);

            setPassword({ ...values })
              .then(() => {
                setIsFetching(false);
                setLocation("/auth/login");
              })
              .catch((err) => {
                setIsFetching(false);
                setErrorMessage("" + err);
              });
          })}
        >
          <Stack>
            <PasswordInput
              required
              disabled={isFetching}
              label="New password"
              placeholder="A new password"
              value={form.values.newPassword}
              onChange={(event) =>
                form.setFieldValue("newPassword", event.currentTarget.value)
              }
              error={form.errors.newPassword}
              radius="md"
            />

            <Group justify="flex-end" mt="xl">
              {/* <Anchor component={Link} href="/auth/login" c="dimmed" size="xs">
                Login
              </Anchor> */}
              <Button type="submit" radius="xl" disabled={isFetching}>
                Set Password
              </Button>
            </Group>

            <Center>{isFetching && <Loader />}</Center>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
